import { getMyUser, type MyUser } from '@echo/api-client/onearly';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '../query/keys';
import { useSession } from './provider';

/**
 * The signed-in OnEarly user (`GET /api/v1/users/me`) — the greeting's name and, later,
 * the profile. Runs only while authenticated; `app` keeps the same one-minute staleness.
 */
export function useMe(enabled = true) {
  const session = useSession();
  return useQuery({
    queryKey: queryKeys.me(),
    enabled: enabled && session.status === 'authenticated',
    staleTime: 60_000,
    queryFn: async (): Promise<MyUser> => {
      const response = await getMyUser();
      if (response.status !== 200) throw new Error(`OnEarly: unexpected status ${response.status}`);
      return response.data;
    },
  });
}
